/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetIncomeMonthRequest
 */
export interface AssetIncomeMonthRequest {
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    year: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    month: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    paidAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    garnishedAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    expenseAllowance: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    familyAllowance: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    employerSettledExpenses: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeMonthRequest
     */
    specialPaymentPaid: boolean | null;
}

/**
 * Check if a given object implements the AssetIncomeMonthRequest interface.
 */
export function instanceOfAssetIncomeMonthRequest(value: object): value is AssetIncomeMonthRequest {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('paidAmount' in value) || value['paidAmount'] === undefined) return false;
    if (!('garnishedAmount' in value) || value['garnishedAmount'] === undefined) return false;
    if (!('expenseAllowance' in value) || value['expenseAllowance'] === undefined) return false;
    if (!('familyAllowance' in value) || value['familyAllowance'] === undefined) return false;
    if (!('employerSettledExpenses' in value) || value['employerSettledExpenses'] === undefined) return false;
    if (!('specialPaymentPaid' in value) || value['specialPaymentPaid'] === undefined) return false;
    return true;
}

export function AssetIncomeMonthRequestFromJSON(json: any): AssetIncomeMonthRequest {
    return AssetIncomeMonthRequestFromJSONTyped(json, false);
}

export function AssetIncomeMonthRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetIncomeMonthRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'],
        'month': json['month'],
        'paidAmount': json['paidAmount'],
        'garnishedAmount': json['garnishedAmount'],
        'expenseAllowance': json['expenseAllowance'],
        'familyAllowance': json['familyAllowance'],
        'employerSettledExpenses': json['employerSettledExpenses'],
        'specialPaymentPaid': json['specialPaymentPaid'],
    };
}

export function AssetIncomeMonthRequestToJSON(json: any): AssetIncomeMonthRequest {
    return AssetIncomeMonthRequestToJSONTyped(json, false);
}

export function AssetIncomeMonthRequestToJSONTyped(value?: AssetIncomeMonthRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'month': value['month'],
        'paidAmount': value['paidAmount'],
        'garnishedAmount': value['garnishedAmount'],
        'expenseAllowance': value['expenseAllowance'],
        'familyAllowance': value['familyAllowance'],
        'employerSettledExpenses': value['employerSettledExpenses'],
        'specialPaymentPaid': value['specialPaymentPaid'],
    };
}

